import { Component } from '@angular/core';

@Component({
  selector: 'app-balance-balances',
  templateUrl: './balance-balances.component.html',
  styleUrls: ['./balance-balances.component.scss']
})
export class BalanceBalancesComponent {
}
